﻿import { create } from 'zustand';

export const useFormsStore = create((set) => ({
  forms: [],
  availableDocuments: [],
  loading: false,
  error: null,
  paginationData: {
    totalRecords: 0,
    totalPages: 0,
    currentPage: 1,
    pageSize: 10,
  },
  searchParams: {
    page: 1,
    pageSize: 10,
    sortBy: 'id',
    sortDirection: 'asc',
    search: '',
  },
  columnFilters: {},
  uniqueValues: {},
  isFormOpen: false,
  isDeleteDialogOpen: false,
  isDocumentSelectionOpen: false,
  currentForm: null,

  setForms: (forms) => set({ forms }),
  setAvailableDocuments: (availableDocuments) => set({ availableDocuments }),
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error }),
  setPaginationData: (paginationData) => set({ paginationData }),
  setUniqueValues: (uniqueValues) => set({ uniqueValues }),
  setColumnFilters: (columnFilters) => set({ columnFilters }),
  setSearchParams: (params) =>
    set((state) => ({
      searchParams: { ...state.searchParams, ...params },
    })),

  openAddForm: () => set({ isFormOpen: true, currentForm: null }),
  openEditForm: (form) => set({ isFormOpen: true, currentForm: form }),
  closeForm: () => set({ isFormOpen: false, currentForm: null }),

  openDeleteDialog: (form) => set({ isDeleteDialogOpen: true, currentForm: form }),
  closeDeleteDialog: () => set({ isDeleteDialogOpen: false, currentForm: null }),

  openDocumentSelection: () => set({ isDocumentSelectionOpen: true }),
  closeDocumentSelection: () => set({ isDocumentSelectionOpen: false }),

  clearError: () => set({ error: null }),
  set: (updater) => set(updater),
}));
